import React from 'react';
import styles from '../../styles/stats-widget-placeholders.module.scss'
import classNames from "classnames";

export const StatsWidgetPlaceholderStat = () => {
  return (
    <div className={classNames(styles.stat)}>
      <div className={classNames(styles.value)}/>
      <div className={classNames(styles.label)}/>
      <div className={classNames(styles.value)}/>
    </div>
  )
};